import * as React from "react";
import { AntDesignProvider, OpenDashContext } from "..";
const NestedProviders = React.memo(function NestedProviders({ providers, children }) {
    if (providers.length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    const [Provider, props] = providers[0];
    return (React.createElement(Provider, Object.assign({}, props),
        React.createElement(NestedProviders, { providers: providers.slice(1), children: children })));
});
export function OpenDashProvider({ app, children }) {
    const providers = app._internal.providerComponents;
    return (React.createElement(OpenDashContext.Provider, { value: app },
        React.createElement(AntDesignProvider, null,
            React.createElement(NestedProviders, { providers: providers, children: children }))));
}
//# sourceMappingURL=OpenDashProvider.js.map